import makeUrl from "../../utils/make-url";
import config from "../config";

const routes = config.profile;
const root = `/${routes.root}`;

export const index = (...args) => makeUrl(root, ...args);
export const transactions = (...args) =>
  makeUrl(`${root}/${routes.transactionHistory.root}`, ...args);
export const transactionDetail = (type, ...args) =>
  makeUrl(`${root}/${routes.transactionHistory.root}/${type}`, ...args);

export const gamesHistory = (...args) =>
  makeUrl(`${root}/${routes.gamesHistory}`, ...args);
export const achievements = (...args) =>
  makeUrl(`${root}/${routes.achievements}`, ...args);
export const bonus = (...args) => makeUrl(`${root}/${routes.bonus}`, ...args);
export const loyaltyProgram = (...args) =>
  makeUrl(`${root}/${routes.loyaltyProgram.root}`, ...args);
export const loyaltyProgramRules = (...args) =>
  makeUrl(`${root}/${routes.loyaltyProgram.rules}`, ...args);
export const loyaltyProgramRanks = (...args) =>
  makeUrl(`${root}/${routes.loyaltyProgram.ranks}`, ...args);
export const cashback = (...args) =>
  makeUrl(`${root}/${routes.cashback}`, ...args);
export const inviteFriend = (...args) =>
  makeUrl(`${root}/${routes.inviteFriend}`, ...args);
export const notification = (...args) =>
  makeUrl(`${root}/${routes.notification}`, ...args);
export const safety = (...args) => makeUrl(`${root}/${routes.safety}`, ...args);
export const personal = (...args) =>
  makeUrl(`${root}/${routes.personal}`, ...args);
export const personalInfo = (...args) =>
  makeUrl(`${root}/${routes.personalInfo}`, ...args);
export default {
  index,
  transactions,
  transactionDetail,
  gamesHistory,
  achievements,
  bonus,
  loyaltyProgram,
  loyaltyProgramRules,
  loyaltyProgramRanks,
  cashback,
  inviteFriend,
  notification,
  safety,
  personal,
  personalInfo,
};
